
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceOwnerOccupier: 'ownershipChange.ownerAndOccupier',
  nmInterfaceFiles: 'ownershipChange.files',
  nmInterfaceDates: 'ownershipChange.dates',
  nmInterfaceUpdateConsumerUnit: 'consumerUnit.alterarServiceRequest',
  nmInterfaceUpdatePhysicalPerson: 'physicalPerson.alterar',
  nmInterfaceUpdateLegalEntity: 'legalEntity.alterar',

  loadCards: async function (consumerUnit) {
    return await repository.resolveLogic(
      'consumerUnit.searchClientUnit',
      { consumerUnit: consumerUnit }
    )
  },

  loadCadClient: async function () {
    const formOwnerOccupier = await repository.resolve(
      this.nmInterfaceOwnerOccupier
    )
    const formFiles = await repository.resolve(this.nmInterfaceFiles)
    const formDates = await repository.resolve(this.nmInterfaceDates)

    return { formFiles, formDates, formOwnerOccupier }
  },

  updateConsumerUnit: async function (consumerUnit) {
    await repository.update(this.nmInterfaceUpdateConsumerUnit, consumerUnit)
  },

  resolveCardClient: async function (dadosForm, isPesrson) {
    return await repository.resolve(
      isPesrson
        ? this.nmInterfaceUpdatePhysicalPerson
        : this.nmInterfaceUpdateLegalEntity,
      dadosForm
    )
  },

  saveCardClient: async function (dadosForm, isPesrson) {
    return await repository.update(
      isPesrson
        ? this.nmInterfaceUpdatePhysicalPerson
        : this.nmInterfaceUpdateLegalEntity,
      dadosForm
    )
  },

  loadClientUnitCard: async function (consumerUnit) {
    const datatable = await repository.resolveDatatable(
      'consumerUnitClientHistoryField.pesquisarHistoryByConsumerUnit'
    )
    const { registros } = await repository.resolveDatatableModel(
      'consumerUnitClientHistoryField.pesquisarHistoryByConsumerUnit',
      { consumerUnit: consumerUnit }
    )
    return { datatable, registros }
  }

}
